import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {DialogsDetailsComponent} from './dialogs-details.component';

const routes: Routes = [
  {path: 'dialogs/details', component: DialogsDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class DialogsDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/dialogs-details-routing.module.ts